var _path, _path2, _path3, _polygon, _circle, _path4, _circle2, _path5, _path6, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadiogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "608.084px",
    height: "167.75px",
    viewBox: "0 0 608.084 167.75",
    enableBackground: "new 0 0 608.084 167.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "radiogo"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M54.896,53.287c-9.643,0-22.445,5.784-22.445,16.069c0,4.052,0,3.797,0,7.241c0,0,0,47.524,0,48.511H3.382V30.219 H32.45c0,0.883,0,6.501,0,7.525c6.447-7.158,16.348-7.308,22.445-7.488C54.896,31.258,54.896,43.013,54.896,53.287z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M125.698,30.484c0,0,0,2.525,0,7.515c-7.052-4.024-16.076-6.396-24.251-6.396 c-25.777,0-46.747,20.884-46.747,46.554c0,25.669,20.97,46.553,46.747,46.553c8.176,0,17.199-2.116,24.251-6.142 c0,4.472,0,6.488,0,6.488h27.416V30.484H125.698z M101.204,99.896c-11.998,0-21.725-9.726-21.725-21.723 c0-12,9.727-21.727,21.725-21.727c11.999,0,21.725,9.727,21.725,21.727C122.929,90.171,113.203,99.896,101.204,99.896z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M230.865,4.056c0,0,0,22.165,0,33.689c-5.319-2.959-16.076-6.142-24.251-6.142 c-25.776,0-46.747,20.884-46.747,46.554c0,25.669,20.971,46.553,46.747,46.553c8.176,0,16.347-1.828,23.197-6.142 c0,2.425,0,3.76,0,3.76v1.31v1.419h28.47c0,0,0-0.634,0-1.419V4.056H230.865z M206.588,99.896 c-11.998,0-21.725-9.726-21.725-21.723c0-12,9.727-21.727,21.725-21.727s21.726,9.727,21.726,21.727 C228.313,90.171,218.586,99.896,206.588,99.896z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "i",
    points: "293.259,36.2 293.259,125.107 265.843,125.107 265.843,36.2 293.259,36.2  "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "i2",
    cx: 279.541,
    cy: 17.776,
    r: 13.224
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M363.308,93.079c-3.96,4.195-9.569,6.817-15.795,6.817c-11.999,0-21.725-9.726-21.725-21.723 c0-6.226,2.621-11.836,6.817-15.797l-17.391-17.39c-8.647,8.452-14.022,20.216-14.022,33.209c0,25.669,20.97,46.554,46.747,46.554 c12.978,0,24.733-5.296,33.212-13.828L363.308,93.079z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o2_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.999,
    y1: 78.166,
    x2: 366.043,
    y2: 78.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED1C24"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "o2",
    fill: "url(#o2_2_)",
    cx: 348.521,
    cy: 78.166,
    r: 17.522
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M473.686,30.757c0,0,0,3.514,0,7.241c-7.026-4.01-16.021-6.118-24.165-6.118c-25.685,0-46.58,20.809-46.58,46.386 c0,25.578,20.896,46.387,46.58,46.387c8.094,0,17.052-2.095,24.059-6.074c0.75,3.909,0.075,11.135-1.991,14.096 c-3.067,4.398-9.058,7.204-16.437,7.698c-11.29,0.752-19.996-6.566-23.914-10.627c-0.498-0.514-0.363-0.391-0.855-0.884 l-19.64,15.192c0.604,0.644,0.452,0.583,1.103,1.181c18.864,17.355,34.718,18.85,41.369,18.85c0.396,0,0.757-0.002,1.082-0.006 l0.774-0.004c29.61,0,45.917-16.845,45.917-47.432l0.015-11.995V30.757H473.686z M449.864,99.896 c-11.999,0-21.726-9.726-21.726-21.723c0-12,9.727-21.727,21.726-21.727c11.998,0,21.724,9.727,21.724,21.727 C471.588,90.171,461.862,99.896,449.864,99.896z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "o_1_",
    d: "M555.339,31.643c-13.277,0-25.277,5.539-33.795,14.419l17.765,17.765c3.982-4.521,9.811-7.38,16.308-7.38 c12,0,21.726,9.727,21.726,21.727c0,6.497-2.856,12.326-7.379,16.307l17.501,17.501c8.999-8.489,14.62-20.496,14.62-33.786 C602.084,52.525,581.114,31.643,555.339,31.643z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o2_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.1602,
    y1: 78.166,
    x2: 573.2021,
    y2: 78.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED1C24"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "o2_1_",
    fill: "url(#o2_3_)",
    cx: 555.681,
    cy: 78.166,
    r: 17.521
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiogo);
export default __webpack_public_path__ + "static/media/radiogo.7ae984c6b64efefaf67cec6da3857d05.svg";
export { ForwardRef as ReactComponent };